import React from 'react';
import { BrowserRouter, Routes, Route, Link } from 'react-router-dom';
import LandingPage from './pages/landingPage';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactUsPage';
import UserProfilePage from './pages/UserProfilePage';
import DashboardLayout from './pages/DashboardLayout';
import DashboardOverview from './pages/DashboardOverview';
import DashboardSettings from './pages/DashboardSettings';
import PreviousWorkPage from './pages/PreviousWorkPage';
import NewsHqProjectPage from './pages/News/NewsHqProjectPage';
import MainLayout from './components/MainLayout';
import LandmarkPage from './pages/LandmarkPage';
import MachineriesPage from './pages/MachineriesPage';
import OurWorkPage from './pages/OurWorkPage';
import OurExpertisePage from './pages/OurExpertisePage';
import CompanyBgPage from './pages/CompanyBgPage';
import BusinessActivityPage from './pages/BusinessActivityPage';
import NewsPage from './pages/NewsPage';
import NewsDetailPage from './pages/NewsDetailPage';
import LoginPage from './pages/LoginPage';
import AdminPage from './pages/AdminPage';
import ProtectedRoute from './components/ProtectedRoute';
import AdminMachineryPage from './pages/AdminMachineryPage';
import AdminVehiclesPage from './pages/AdminVehiclesPage';
import OurCertificatesPage from './pages/OurCertificatesPage';
import OrganizationStructurePage from './pages/OrganizationStructurePage';

import AdminLandmarkPage from './pages/AdminLandmarkPage';

import AdminNewsPage from './pages/AdminNewsPage';
import AdminEventsPage from './pages/AdminEventsPage';
import EventsPage from './pages/EventsPage';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<MainLayout />}>
          <Route path="/" element={<LandingPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/users/:userId" element={<UserProfilePage />} />
          <Route path="/previous-work" element={<PreviousWorkPage />} />
          <Route path="/news-hq-project" element={<NewsHqProjectPage />} />
          <Route path="/landmark" element={<LandmarkPage />} />
          <Route path="/machineries" element={<MachineriesPage />} />
          <Route path="/our-works" element={<OurWorkPage />} />
          <Route path="/our-expertise" element={<OurExpertisePage />} />
          <Route path="/company-background" element={<CompanyBgPage />} />
          <Route path="/business-activity" element={<BusinessActivityPage />} />
          <Route path="/news" element={<NewsPage />} />
          <Route path="/news/:id" element={<NewsDetailPage />} />
          <Route path="/events" element={<EventsPage />} />
          <Route path="/our-certificates" element={<OurCertificatesPage />} />
          <Route path="/organization-structure" element={<OrganizationStructurePage />} />
        </Route>
        <Route path="/login" element={<LoginPage />} />
        {/* Admin Routes */}
        <Route path="/admin" element={<ProtectedRoute><AdminPage /></ProtectedRoute>} />
        <Route path="/admin/news" element={<ProtectedRoute><AdminNewsPage /></ProtectedRoute>} />
        <Route path="/admin/events" element={<ProtectedRoute><AdminEventsPage /></ProtectedRoute>} />
        <Route path="/admin/landmarks" element={<ProtectedRoute><AdminLandmarkPage /></ProtectedRoute>} />
        <Route path="/admin/vehicles" element={<ProtectedRoute><AdminVehiclesPage /></ProtectedRoute>} />
        <Route path="/admin/machinery" element={<ProtectedRoute><AdminMachineryPage /></ProtectedRoute>} />
        <Route path="/dashboard" element={<DashboardLayout />}>
          <Route index element={<DashboardOverview />} />
          <Route path="settings" element={<DashboardSettings />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
